import { FillItemContent, FillItemContentSpecialized, KeySystemRootKeyStorageMode, } from '@standardnotes/models';
import { ContentType } from '@standardnotes/domain-core';
export class ProcessAcceptedVaultInvite {
    constructor(mutator, sync, _createOrEditContact) {
        this.mutator = mutator;
        this.sync = sync;
        this._createOrEditContact = _createOrEditContact;
    }
    async execute(message, sharedVaultUuid, ownerUuid) {
        const { rootKey: rootKeyContent, trustedContacts, metadata } = message.data;
        const content = {
            systemIdentifier: rootKeyContent.systemIdentifier,
            rootKeyParams: rootKeyContent.keyParams,
            keyStorageMode: KeySystemRootKeyStorageMode.Synced,
            name: metadata.name,
            description: metadata.description,
            iconString: metadata.iconString,
            sharing: {
                sharedVaultUuid: sharedVaultUuid,
                ownerUserUuid: ownerUuid,
                fileBytesUsed: metadata.fileBytesUsed,
                designatedSurvivor: metadata.designatedSurvivor,
            },
        };
        await this.mutator.createItem(ContentType.TYPES.KeySystemRootKey, FillItemContent(rootKeyContent), true);
        await this.mutator.createItem(ContentType.TYPES.VaultListing, FillItemContentSpecialized(content), true);
        for (const contact of trustedContacts) {
            await this._createOrEditContact.execute({
                name: contact.name,
                contactUuid: contact.contactUuid,
                publicKey: contact.publicKeySet.encryption,
                signingPublicKey: contact.publicKeySet.signing,
            });
        }
        void this.sync.sync({ sourceDescription: 'Not awaiting due to this event handler running from sync response' });
    }
}
